import { useTranslator } from "@eo-locale/react";

import { reportMarker } from "@/redux/features/place-marker/thunk";
import { useAppDispatch, useAppSelector } from "@/redux/store/hooks";
import { AlertDialog, useToast } from "@/storybook-components";

interface IReportPin {
  markerId: string;
  isOpen: boolean;
  onClose: () => void;
}

const ReportPin = (props: IReportPin) => {
  const { isOpen, onClose } = props;
  const { translate } = useTranslator();
  const dispatch = useAppDispatch();

  const projectId = useAppSelector((state) => state.project.project.id);
  const placesId = useAppSelector((state) => state.place.place.id);

  const toast = useToast({
    isClosable: true,
    containerStyle: {
      marginBottom: "1 !important"
    }
  });

  const closeAlert = () => {
    onClose();
  };

  const handleError = () => {
    if (!toast.isActive("places-toast")) {
      toast({
        id: "places-toast",
        title: translate("errors.sorrySomethingWentWrong"),
        status: "error"
      });
    }
  };

  const handleReportPin = async () => {
    const { markerId } = props;
    try {
      const res: any = await dispatch(
        reportMarker({ projectId, placesId, markerId })
      );

      const responseStatus = res.payload?.status;
      if (responseStatus) {
        handleError();
        return;
      }

      if (!toast.isActive("places-delete-toast")) {
        toast({
          title: translate("places.pin.reportPinSuccess"),
          id: "places-delete-toast",
          status: "info"
        });
      }
      // eslint-disable-next-line no-unused-vars
    } catch (error) {
      handleError();
    }
  };

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={closeAlert}
      header={translate("places.pin.reportPinHeader")}
      body={translate("places.pin.reportPinBody")}
      buttonPrimary={translate("common.yes")}
      buttonSecondary={translate("common.no")}
      buttonPrimaryVariant={"primary"}
      buttonSecondaryVariant={"secondary"}
      isSecondaryDestructive={false}
      onPrimaryClickHandler={() => {
        handleReportPin();
        closeAlert();
      }}
      onSecondaryClickHandler={closeAlert}
    />
  );
};

export default ReportPin;
